import React, { useState, useEffect, useContext } from "react";
import CompanyInfoModal from "~/pages/applyFormMange/modals/CompanyInfoModal";
import useAlert from "~/common/hooks/useAlert";

import InqueryForm from "./inputComponent/applyInquriy/InqueryForm";
import useRequest from "~/common/hooks/useRequest";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { API_STATE } from "~/common/constants/state";
import { useNavigate } from "react-router";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
const ApplyFormMange = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { formDetail, applyMangeForm, list, qList, mainImg, reviewSettingIdx, isUse } = useContext(ApplyContext);
	const [showWarningAlert, Warning] = useAlert();
	const [warningMsg, setWarningMsg] = useState("");
	const [companyInfoModal, setCompanyInfoModal] = useState();
	const [showEditSuccess, EditSuccess] = useAlert();
	const applyRegRequest = useRequest("post", "/vc/apply/template");
	useEffect(() => {
		formDetail();
	}, []);
	const inquiryInput = applyMangeForm.watch("inquiry");
	const inquiryDescInput = applyMangeForm.watch("inquiryDesc");
	const submit = (data) => {
		let validationFailed = false;
		// 단일선택형, 다중선택형 옵션 validation
		list.map((i) => {
			if (
				(i.type === "SELECT" || i.type === "MULTISELECT") &&
				i.title !== "국가" &&
				i.title !== "투자단계" &&
				i.title !== "산업분야"
			) {
				const removeEmptyElement = i.option.filter((item) => item !== "");
				if (removeEmptyElement.length === 0) {
					validationFailed = true;
					setWarningMsg("옵션을 추가해주세요.");
					return showWarningAlert();
				}

				if (new Set(removeEmptyElement).size !== removeEmptyElement.length) {
					validationFailed = true;
					setWarningMsg("동일한 옵션을 입력했습니다.");
					return showWarningAlert();
				}
			}
		});
		if (validationFailed) return;
		const formData = {
			image: {
				name: "",
				size: 0,
				path: mainImg,
			},
			reviewSettingIdx: reviewSettingIdx,
			title: inquiryInput,
			description: inquiryDescInput,
			inputs: list,
			qna: qList,
			isUse: isUse,
			containInfoContents: true,
		};
		applyRegRequest.call(formData);
	};
	useEffect(() => {
		switch (applyRegRequest.state) {
			case API_STATE.done:
				showEditSuccess().then(() => navigate("/applyForm/view"));
				break;
			case API_STATE.error:
				setWarningMsg(t("pages.applyFormMange.ApplyForm.setWarningMsg"));
				showWarningAlert();
				break;

			default:
				break;
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applyRegRequest.state, applyRegRequest.response, applyRegRequest.error]);
	return (
		<>
			<Helmet>
				<title>{getTitle(t("pages.applyFormMange.ApplyForm.title"))}</title>
			</Helmet>
			<div className="p__apply-FormMange light">
				<InqueryForm />

				{/*	취소하기, 저장하기 버튼 */}
				<div className="btn__group">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => navigate("/applyForm/view")}
					>
						{t("pages.applyFormMange.ApplyForm.btn-cancel")}
					</button>
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={applyMangeForm.handleSubmit(submit)}
					>
						{t("pages.applyFormMange.ApplyForm.btn-save")}
					</button>
				</div>
			</div>
			<EditSuccess
				type="success"
				message={t("pages.applyFormMange.ApplyForm.successMassage")}
				confirm={t("common.commonWord.button.check")}
			/>
			{/*기본 기업 정보 모달*/}
			<CompanyInfoModal {...{ companyInfoModal, setCompanyInfoModal }} />
			<Warning
				type="info"
				message={
					warningMsg === "동일한 옵션을 입력했습니다."
						? "중복 사항 확인"
						: t("pages.applyFormMange.ApplyForm.WarningMassage")
				}
				subMessage={warningMsg}
				confirm={t("common.commonWord.button.check")}
			/>
		</>
	);
};

export default ApplyFormMange;
